import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconFlagFr = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 512 512" size={size}>
      <g>
        <rect fill="#324095" height="298.7" id="XMLID_4_" width="170.7" x="0" y="106.7" />
        <rect fill="#F4F4F4" height="298.7" id="XMLID_3_" width="170.7" x="170.7" y="106.7" />
        <rect fill="#D81E34" height="298.7" id="XMLID_2_" width="170.7" x="341.3" y="106.7" />
      </g>
    </BaseIcon>
  );
}

export default IconFlagFr;